/* src/app/main-layout/components/configurator-3d-btn/configurator-3d-btn.component.css */
@layer properties;
div {
  position: relative;
  overflow: hidden;
}
a {
  display: block;
  border-radius: var(--radius-sm, 0.25rem);
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: var(--color-primary-500, #257948);
  background-color: color-mix(in srgb, #257948 20%, transparent);
  padding-inline: calc(var(--spacing, 0.25rem) * 8);
  padding-block: calc(var(--spacing, 0.25rem) * 2);
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
  color: var(--color-primary-500, #257948);
  transition-property:
    color,
    background-color,
    border-color,
    outline-color,
    text-decoration-color,
    fill,
    stroke,
    --tw-gradient-from,
    --tw-gradient-via,
    --tw-gradient-to;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
  --tw-duration: 150ms;
  transition-duration: 150ms;
  --tw-ease: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
  transition-timing-function: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
}
@supports (color: color-mix(in lab, red, red)) {
  a {
    background-color: color-mix(in oklab, var(--color-primary-500, #257948) 20%, transparent);
  }
}
@media (hover: hover) {
  a:hover {
    background-color: var(--color-primary-500, #257948);
  }
}
@media (hover: hover) {
  a:hover {
    color: var(--color-white, #fff);
  }
}
a.disabled {
  pointer-events: none;
  cursor: pointer;
}
a::after {
  content: "";
  position: absolute;
  top: calc(var(--spacing, 0.25rem) * 1.5);
  left: calc(var(--spacing, 0.25rem) * -3);
  display: block;
  height: calc(var(--spacing, 0.25rem) * 3);
  width: calc(var(--spacing, 0.25rem) * 12);
  rotate: calc(45deg * -1);
  background-color: var(--color-primary-500, #257948);
  transition-property:
    color,
    background-color,
    border-color,
    outline-color,
    text-decoration-color,
    fill,
    stroke,
    --tw-gradient-from,
    --tw-gradient-via,
    --tw-gradient-to;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
  --tw-duration: 150ms;
  transition-duration: 150ms;
  --tw-ease: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
  transition-timing-function: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
}
a:hover::after {
  background-color: color-mix(in srgb, #fff 40%, transparent);
}
@supports (color: color-mix(in lab, red, red)) {
  a:hover::after {
    background-color: color-mix(in oklab, var(--color-white, #fff) 40%, transparent);
  }
}
i {
  position: absolute;
  top: calc(var(--spacing, 0.25rem) * 2);
  left: calc(var(--spacing, 0.25rem) * 2);
  font-size: 0.5rem;
  color: var(--color-white, #fff);
}
i.icon-1 {
  top: 0.0625rem;
  left: 0.9375rem;
}
i.icon-3 {
  top: 0.9375rem;
  left: 0.0625rem;
}
@property --tw-border-style { syntax: "*"; inherits: false; initial-value: solid; }
@property --tw-font-weight { syntax: "*"; inherits: false; }
@property --tw-duration { syntax: "*"; inherits: false; }
@property --tw-ease { syntax: "*"; inherits: false; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=configurator-3d-btn.component.css.map */
